import React from "react";
// recoil
import { useRecoilState } from "recoil";
// @Mui
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
// atoms
import tutorialPopUpAtom from "src/recoil/atoms/tutorialPopUpAtom";
// hooks
import useLocales from "src/hooks/useLocales";
import Iconify from "./Iconify";

// -----------------------------------------------------------------

function TutorialPopUp() {
  const { translate, currentLang } = useLocales();

  const [tutorialPopUp, setTutorialPopUp] = useRecoilState(tutorialPopUpAtom);

  const closeHandler = () => {
    setTutorialPopUp(false);
  };

  const tutorialData = [
    {
      enTitle: "Home Page Explaination",
      arTitle: "شرح الصقحة الرئيسية",
      videoLink: "https://youtu.be/bqih1g-p8jI?si=gizNkKe96YOO0vKV",
    },
    {
      enTitle: "Workout Program Explaination",
      arTitle: "شرح نظام التدريب",
      videoLink: "https://youtu.be/76QsZ4Y9KbM?si=qoGox67CPmxpFajK",
    },
    {
      enTitle: "Nutrition Program Explaination",
      arTitle: "شرح نظام الدايت",
      videoLink: "https://youtu.be/NDiwMkBvg_U?feature=shared",
    },
  ];

  return (
    <Dialog open={tutorialPopUp} onClose={closeHandler} fullWidth>
      <DialogTitle>
        {translate("componentsTranslations.tutorialPopUpTranslations.title")}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 3 }}>
          <List>
            {tutorialData.map((_, index) => (
              <ListItem
                key={index}
                secondaryAction={
                  <Tooltip title="Watch video">
                    <IconButton onClick={() => window.open(_.videoLink)}>
                      <Iconify icon="radix-icons:video" />
                    </IconButton>
                  </Tooltip>
                }
              >
                <ListItemText
                  primary={
                    <Typography variant="h6">
                      {currentLang.value === "en" ? _.enTitle : _.arTitle}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default TutorialPopUp;
